// Tenant-level SMS daily cap: hard limit of outbound texts per day. Backend
// contract: 1..1000000 for a cap, -1 for "no cap", null to clear the override
// (falls back to the backend's default of 2000).

export const DAILY_CAP_MIN = 1;
export const DAILY_CAP_MAX = 1_000_000;
export const DAILY_CAP_NO_CAP = -1;

/**
 * The three states the editor tracks. 'number' means the input holds a cap;
 * 'noCap' means the "no cap" toggle is on; and the stored value may be either.
 */
export type DailyCapMode = 'number' | 'noCap';

/** True when the stored value represents "no cap" (-1 in the backend). */
export const isNoCapValue = (dailyCap: number): boolean => dailyCap === DAILY_CAP_NO_CAP;

/** The input in 'number' mode is a positive integer in the backend range. */
export const validateDailyCapInput = (value: string): string | true => {
    if (value.trim() === '') return 'Enter a cap or switch to no cap';
    const parsed = Number(value);
    if (!Number.isInteger(parsed) || parsed < DAILY_CAP_MIN || parsed > DAILY_CAP_MAX) {
        return `Enter a whole number between ${DAILY_CAP_MIN} and ${DAILY_CAP_MAX.toLocaleString()}`;
    }
    return true;
};
